import test from '../../../assets/img/ecommerce/banners/Vector299.png'
import test3 from '../../../assets/img/ecommerce/banners/Vector298.png'
import subject from '../../../assets/img/ecommerce/banners/Subject.png'

const EcomLargeBanner = () => {
  return (
    <div
      className="container-large rounded-3 overflow-hidden"
      style={{
        backgroundColor: '#ecebec',
        height: '90%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative', // Required for absolute positioning
      }}
    >
      <div className="image-wrapper">
        <img src={subject} alt="Banner" className="banner-image" />
      </div>

      {/* Text in Top Right */}
      <div className="top-right-text text-end text-gradient-info">
        <h1 className="fs-lg-3 fs-md-6 fs-sm-6 fs-8">Ofrece tus </h1>
        <h1 className="fs-lg-3 fs-md-6 fs-sm-6 fs-8">Servicios</h1>
      </div>

      {/* Text in Bottom Left */}
      <div className="bottom-left-text">
        <h1
          className="fs-lg-3 fs-md-6 fs-sm-6 fs-8"
          style={{
            background: 'linear-gradient(90deg, #FF7A07, #FF3434, #F441FF, #3988FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Contrata
        </h1>
        <h1
          className="fs-lg-3 fs-md-6 fs-sm-6 fs-8"
          style={{
            background: 'linear-gradient(90deg, #FF7A07, #FF3434, #F441FF, #3988FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Proveedores
        </h1>
      </div>

      {/* Left Aligned Test Image */}
      <img
        src={test}
        alt="Banner"
        style={{
          position: 'absolute',
          right: '0',
          maxHeight: '90%', // Adjust as needed
          maxWidth: '70%', // Adjust as needed
          height: 'auto',
          opacity: '0.9',
          bottom: '0',
        }}
      />

      {/* Shrunk Test3 Image */}
      <img
        src={test3}
        alt="Banner"
        style={{
          position: 'absolute',
          right: '0',
          bottom: '0',
          maxWidth: '80%', // Adjust as needed
          height: 'auto',
          opacity: '0.5',
        }}
      />
    </div>
  )
}

export default EcomLargeBanner
